var Sugar = require('sugar');
require('jquery-validation');

$(document).ready(function () {

    var html = $('label[for="contact_privacy"]').html();
    html = html.replace(/\[\[(.+)\]\]/, '<a href="' + privacyUrl + '" target="_blank">$1</a>');
    $('label[for="contact_privacy"]').html(html);

    Sugar.extend();

    var $form = $('form[name="contact"]');
    var error = $('.alert-danger', $form);
    var success = $('.alert-success', $form);

    console.log('Contact Form Validator');

    $form.validate({
        doNotHideMessage: true, //this option enables to show the error/success messages on tab switch.
        errorElement: 'span', //default input error message container
        errorClass: 'help-block help-block-error', // default input error message class
        focusInvalid: false, // do not focus the last invalid input
        rules: {
            'contact[name]': {
                required: true
            },
            'contact[email]': {
                required: true,
                email: true
            },
            'contact[subject]': {
                required: true
            },
            'contact[message]': {
                required: true
            },
            'contact[privacy]': {
                required: true
            }
        },

        messages: { // custom messages for radio buttons and checkboxes
            'contact[name]': {
                required: Translator.trans('contact.error.form.name.required', {}, 'contact')
            },
            'contact[email]': {
                required: Translator.trans('contact.error.form.email.required', {}, 'contact'),
                email: Translator.trans('contact.error.form.email.email', {}, 'contact')
            },
            'contact[subject]': {
                required: Translator.trans('contact.error.form.subject.required', {}, 'contact')
            },
            'contact[message]': {
                required: Translator.trans('contact.error.form.message.required', {}, 'contact')
            },
            'contact[privacy]': {
                required: Translator.trans('contact.error.form.privacy.required', {}, 'contact')
            }
        },

        errorPlacement: function (error, element) { // render error placement for each input type
            if (element.attr("type") == "checkbox") { // for uniform radio buttons, insert the after the given container
                error.insertAfter(element.closest('div').find('label'));
            } else {
                error.insertAfter(element); // for other inputs, just perform default behavior
            }
        },

        invalidHandler: function (event, validator) { //display error alert on form submit
            success.hide();
            error.show();
        },

        highlight: function (element) { // hightlight error inputs
            $(element).closest('.form-group').removeClass('has-success').addClass('has-error'); // set error class to the control group
        },

        unhighlight: function (element) { // revert the change done by hightlight
            $(element).closest('.form-group').removeClass('has-error'); // set error class to the control group
        },

        success: function (label) {
            if (label.find('input').length > 0) { // for checkboxes and radio buttons, no need to show OK icon
                label.closest('.form-group').removeClass('has-error').addClass('has-success');
                label.remove(); // remove error label here
            } else { // display success icon for other inputs
                label.addClass('valid') // mark the current input as valid and display OK icon
                    .closest('.form-group').removeClass('has-error').addClass('has-success'); // set success class to the control group
            }
        },

        submitHandler: function (form) {
            success.show();
            error.hide();
            // form.submit();
            const $ewzReCaptcaV3 = $('#contact_captchaCode');
            let n = 1;
            if ($ewzReCaptcaV3.length > 0) {
                let checkInterval = setInterval(function () {
                    console.log(n++);
                    if ($ewzReCaptcaV3.val() !== '') {
                        clearInterval(checkInterval);
                        submitHandler(form);
                    }
                }, 100);
            } else {
                submitHandler(form);
            }
        }

    });

    function submitHandler(form) {
        // setup some local variables
        var $form = $(form);
        // let's select and cache all the fields
        var $inputs = $form.find("input, select, button, textarea");
        // serialize the data in the form
        var serializedData = $form.serialize();

        // let's disable the inputs for the duration of the ajax request
        $inputs.prop("disabled", true);

        // fire off the request to /form.php

        var request = $.ajax({
            url: $form.attr('action'),
            type: "post",
            data: serializedData
        });

        // callback handler that will be called on success
        request.done(function (response, textStatus, jqXHR) {
            // log a message to the console
            $form.closest('div').html(response);
        });

        // callback handler that will be called on failure
        request.fail(function (jqXHR, textStatus, errorThrown) {
            // log the error to the console
            console.error(
                "The following error occured: " + textStatus, errorThrown);
        });

        // callback handler that will be called regardless
        // if the request failed or succeeded
        request.always(function () {
            // reenable the inputs
            $inputs.prop("disabled", false);
        });
    }

});